import { GETALERTS } from "./get-alerts.query";
import { IGetAlertsResponse } from "./get-alerts.interface";
import { useCombinedAlertsDataStore } from "../../hooks";
import { useEffect } from "react";
/* eslint-disable max-len */
import { useLazyQuery } from "@apollo/client";

export const useGetAlerts = () => {
  const [getAlerts, { data, loading, refetch }] =
    useLazyQuery<{ getAlerts: IGetAlertsResponse }>(GETALERTS);

  const {
    setIsDuplicateAccount,
    setShouldShowWellnessUpsell,
    setShouldShowPrequalification,
    setShowUrgentVisitUpsell,
    setIsExpressEligible,
    setUpdatePaymentMethod,
    setAlertsDataUpdated,
    setRecentlyEndedWPData,
    setFailedRenewalAfterGrace,
    setFailedRenewalWithGrace,
    setRecentRenewedWPData,
    setEndsSoonWPData,
    setFailedRenewalWPData,
    setScratchpayRenewalPending,
    setShowReferralUpsell,
  } = useCombinedAlertsDataStore();


  useEffect(() => {
    if (data) {
      const alerts = data?.getAlerts?.alerts;

      if (alerts) {
        alerts.isDuplicateAccount && setIsDuplicateAccount(alerts.isDuplicateAccount);
        setShouldShowWellnessUpsell(alerts.shouldShowWellnessUpSell ?? false);
        setShouldShowPrequalification(alerts.shouldShowPrequalification ?? false);
        alerts.urgentVisitUpSell && setShowUrgentVisitUpsell(alerts.urgentVisitUpSell);
        alerts.isExpressEligible && setIsExpressEligible(alerts.isExpressEligible);
        alerts.updatePaymentMethod && setUpdatePaymentMethod(alerts.updatePaymentMethod);
        // wellness alerts
        alerts.recentlyEndedWPData && setRecentlyEndedWPData(alerts.recentlyEndedWPData);
        alerts.failedRenewalsAfterGracePeriodWPData && setFailedRenewalAfterGrace(alerts.failedRenewalsAfterGracePeriodWPData);
        alerts.failedRenewalsWithGracePeriodWPData && setFailedRenewalWithGrace(alerts.failedRenewalsWithGracePeriodWPData);
        alerts.recentRenewedWPData && setRecentRenewedWPData(alerts.recentRenewedWPData);
        alerts.endsSoonWPData && setEndsSoonWPData(alerts.endsSoonWPData);
        alerts.failedRenewalsWPData && setFailedRenewalWPData(alerts.failedRenewalsWPData);
        alerts.scratchpayRenewalPending && setScratchpayRenewalPending(alerts.scratchpayRenewalPending);
        alerts.referralUpSell && setShowReferralUpsell(alerts.referralUpSell);
      }
      setAlertsDataUpdated(true);
    }
  }, [data]);

  return {
    getAlerts,
    getAlertsData: data?.getAlerts?.alerts,
    loading,
    refetch,
  };
};

